import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import KeyFeatures from '../partials/Product/KeyFeatures';
import ContractFeatures from '../partials/Product/ContractFeatures';
import ProductTestimonial from '../partials/Product/ProductTestimonial';
import PricingSection from '../partials/Product/PricingSection';
import '../../../assets/guestportal.css';
import docusafe from '../../../assets/Images/docusafe.png';
import contract from '../../../assets/Images/contract.png';

// Define the checkmark SVG icon as a reusable component
const CheckmarkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#4CAF50" />
    <path d="M4.5 8.75L7 11.25L11.5 6.75" stroke="#fff" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DOCUSAFE_SECTION = (
  <div className="container">
    <div className="row">
      <div className="col-12 col-lg-6">
        <div className="docusafe-label">Document Collection & Management</div>
        <h2 className="docusafe-title">
          DOCUSAFE: COLLECT & MANAGE DOCUMENTS <br />
          <span className="docusafe-highlight">EFFORTLESSLY</span>
        </h2>
        <p className="docusafe-desc">
          The modern solution for requesting, collecting, and organizing documents from clients and team members with automated reminders and secure storage.
        </p>
        <ul className="docusafe-features">
          <li><CheckmarkIcon /> Streamlined document collection process with customizable request templates</li>
          <li><CheckmarkIcon /> Automated reminders to ensure timely document submission</li>
          <li><CheckmarkIcon /> Bank-level encryption for secure document storage and sharing</li>
          <li><CheckmarkIcon /> Intuitive organization system with tags, folders, and search functionality</li>
        </ul>
        <div className="docusafe-btn-row">
          <NavLink to="https://app.docusafe.ai/login" target='_blank' className="contractz-btn-primary mt-2">
            Login
          </NavLink>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <img src={docusafe} alt="docusafe" className="img-fluid" />
      </div>
    </div>
  </div>
);

const CONTRACTZ_SECTION = (
  <div className="container">
    <div className="row">
      <div className="col-12 col-lg-6">
        <div className="contractz-label"><span>Contract Creation & Management</span></div>
        <h2 className="contractz-title">
          CONTRACTS: CREATE & MANAGE AGREEMENTS
          <span className="contractz-highlight"> SEAMLESSLY</span>
        </h2>
        <p className="contractz-desc">
          Draft, send, sign, and store all your contracts in one place with legally vetted templates and electronic signature capabilities.
        </p>
        <ul className="contractz-features">
          <li><CheckmarkIcon /> Library of professionally drafted contract templates for various needs</li>
          <li><CheckmarkIcon /> Customizable clauses and terms to fit your specific requirements</li>
          <li><CheckmarkIcon /> Legally binding electronic signatures for faster deal closing</li>
          <li><CheckmarkIcon /> Contract lifecycle management with expiration alerts and renewals</li>
        </ul>
        <div className="contractz-btn-row">
          <NavLink to="https://contract.docusafe.ai/login" target='_blank' className="contractz-btn-primary">
            Login
          </NavLink>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <img src={contract} alt="contract" className="img-fluid" />
      </div>
    </div>
  </div>
);

const Product = () => {
  const [activeTab, setActiveTab] = useState('docusafe');

  return (
    <section>
      <div className="product-hero-seciton">
        <div className="container">
          <div className="product-hero-label"><span>Document Management Solutions</span></div>
          <h1 className="product-hero-title">
            SIMPLIFY YOUR <br />
            <span className="highlight">DOCUMENT WORKFLOW</span>
          </h1>
          <p className="product-hero-desc">
            Powerful tools to collect, create, and manage your documents and contracts with ease
          </p>
          <div className="product-hero-buttons">
            <button
              className={`product-tab-btn${activeTab === 'docusafe' ? ' active' : ''}`}
              onClick={() => setActiveTab('docusafe')}
            >
              DocuSafe
            </button>
            <button
              className={`product-tab-btn${activeTab === 'contractz' ? ' active' : ''}`}
              onClick={() => setActiveTab('contractz')}
            >
              Contract
            </button>
          </div>
        </div>
      </div>
      <div className="product-tab-section">
        {activeTab === 'docusafe' ? DOCUSAFE_SECTION : CONTRACTZ_SECTION}
      </div>
      {activeTab === 'docusafe' && <KeyFeatures />}
      {activeTab === 'contractz' && <ContractFeatures />}
      {/* <ProductTestimonial /> */}
      <PricingSection />
    </section>
  );
}

export default Product;